import { api } from '@/services';

import { IRoleAssignmentUpdate } from '@/features/role-assignments/interfaces';
import { ROLES_API_ENDPOINTS } from '@/constants';
import { ApiResponse } from '@/types';

const RoleAssignmentCreationService = {
  CreateRoleAssignment: async (
    roleAssignment: IRoleAssignmentUpdate,
  ): Promise<ApiResponse<IRoleAssignmentUpdate>> => {
    const response = await api.put(
      ROLES_API_ENDPOINTS.ROLES_ASSIGNMENTS_ID.replace(':id', ''),
      roleAssignment,
    );
    return response.data;
  },
};

export default RoleAssignmentCreationService;
